import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import FluidBackgroundImg from 'Components/Utility/FluidBackgroundImg';
import 'Components/Blog/BlogHomePageHeader.scss';

const BlogHomePageHeader = () =>
  <React.Fragment>
    {window.location.pathname === '/en/blog' &&
      <Link to="/blog">
        <FluidBackgroundImg
          className="blog-header"
          folder="assets"
          subfolder="banners/takeover"
          src="Blog-TAKEOVER-NEW-SIZE.jpg"
          heights={{ xs: 120, sm: 120, md: 143, lg: 170, xl: 170, xxl: 200 }}
          tagName="header"
          fit="crop"

        >
          <div className="container">
            <div className="heading-container">
              <h1 className="blog-header-title">
                The Fanatical <span>Blog</span>
              </h1>
              <div className="blog-header-point-container">
                <div className="left" />
                <div className="center">
                  <div className="blog-header-point">
                    <FormattedMessage id="blog.header.point" defaultMessage="Latest AAA, Indie & Game Bundles" />
                  </div>
                  <div className="blog-header-point">
                    <FormattedMessage id="blog.header.point2" defaultMessage="Receive Games Instantly" />
                  </div>
                  <div className="blog-header-point">
                    <FormattedMessage id="blog.header.point3" defaultMessage="Save Money" />
                  </div>
                  <div className="blog-header-point no-border">
                    <FormattedMessage id="blog.header.point4" defaultMessage="100% Authentic Keys" />
                  </div>
                </div>
                <div className="right" />
              </div>
            </div>
          </div>
        </FluidBackgroundImg>
      </Link>
    }
  </React.Fragment>;

export default BlogHomePageHeader;
